import React, { useEffect, useState } from 'react';
import { Button, Table, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

const Approval = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [formData, setFormData] = useState({ name: '', mobile: '' }); // State for form inputs
  const [rfidData, setRfidData] = useState({ customerId: '', rfid: '' }); // State for RFID mapping form
  const [tag, setTag] = useState(""); // State to store fetched RFID tag
  const [rfidInputState, setRfidInputState] = useState({}); // State to track input and button state per row

  const apiUrl = 'https://jwapi.infosware-test.in';
  const navigate = useNavigate(); 

  useEffect(() => {
    // Fetch data from the API
    axios.get(`${apiUrl}/api/approval/approval-list`) // Replace with your API endpoint
      .then(response => {
        setData(response.data); // Assuming the API returns an array of objects
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRfidInputChange = (e) => {
    const { name, value } = e.target;
    setRfidData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // Submit the form data to the API
    axios.post(`${apiUrl}/api/approval/add-person`, formData)
      .then(() => {
        toast.success('Person added successfully!');
        setShowModal(false); // Close the modal
        setFormData({ name: '', mobile: '' }); // Reset form
        // Refresh the data to reflect the new entry
        axios.get(`${apiUrl}/api/approval/approval-list`)
          .then(response => setData(response.data))
          .catch(error => console.error('Error refreshing data:', error));
      })
      .catch(error => {
        console.error('Error adding person:', error);
        if (error.response && error.response.status === 400) {
          toast.error('Mobile number already exists. Please use a different number.');
        } else {
          toast.error('Failed to add person. Please try again.');
        }
      });
  };

  const fetchTagID = async (customerId) => {
    try {
      const response = await fetch(`${apiUrl}/api/read-tag`); // Correct URL
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setTag(data.tag);
      setRfidInputState((prev) => ({
        ...prev,
        [customerId]: { rfid: data.tag, isFetched: true },
      }));
    } catch (error) {
      console.error("Error fetching tag ID:", error);
    }
  };

  const handleAddRfid = (customerId) => {
    const rfid = rfidInputState[customerId]?.rfid;
    if (!rfid) {
      toast.warning("Please fetch an RFID first.");
      return;
    }

    axios
      .post(`${apiUrl}/api/approval/map-rfid`, { customerId, rfid })
      .then(() => {
        toast.success("RFID added successfully!");
        setRfidInputState((prev) => ({
          ...prev,
          [customerId]: { rfid: "", isFetched: false },
        }));
        // Refresh the data to reflect the updated count
        axios
          .get(`${apiUrl}/api/approval/approval-list`)
          .then((response) => setData(response.data))
          .catch((error) => console.error("Error refreshing data:", error));
      })
      .catch((error) => {
        console.error("Error adding RFID:", error);
        if (error.response && error.response.data === "Already assigned the item to customer") {
          toast.warning("Already assigned item to customer");
        } else {
          toast.error(`Failed to add RFID: ${error.response?.data || "Unknown error"}`);
        }
      });
     
  };

  const handleDeleteCustomer = (customerId) => {
    axios.delete(`${apiUrl}/api/approval/delete-person/${customerId}`)
      .then(() => {
        toast.success('Customer deleted successfully!');
        // Refresh the data to reflect the deletion
        axios.get(`${apiUrl}/api/approval/approval-list`)
          .then(response => setData(response.data))
          .catch(error => console.error('Error refreshing data:', error));
      })
      .catch(error => {
        console.error('Error deleting customer:', error);
        toast.error('Failed to delete customer. Please try again.');
      });
  };

  const handleNameClick = (customerId, name) => {
    navigate(`/items-assign/${customerId}?name=${encodeURIComponent(name)}`); 
  };

  return (
    <div className="approval-container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Approval List</h2>
        <Button variant="primary" onClick={() => setShowModal(true)}>Add Person</Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sr. No</th>
            <th>Name</th>
            <th>Mobile No</th>
            <th>Count</th>
            <th>Add Items</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td
                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                onClick={() => handleNameClick(item.id, item.name)} // Pass name to the click handler
              >
                {item.name}
              </td>
              <td>{item.mobile}</td>
              <td>{item.count}</td>
              <td className="d-flex align-items-center">
                <input
                  type="text"
                  placeholder="Enter RFID"
                  className="form-control"
                  style={{ height: "100%" }}
                  value={rfidInputState[item.id]?.rfid || ""}
                  readOnly
                />
                {!rfidInputState[item.id]?.isFetched ? (
                  <Button
                    variant="primary"
                    size="sm"
                    style={{ height: "100%", marginLeft: "-1px" }}
                    onClick={() => fetchTagID(item.id)}
                  >
                    Get ID
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="sm"
                    style={{ height: "100%", marginLeft: "-1px" }}
                    onClick={() => handleAddRfid(item.id)}
                  >
                    Add
                  </Button>
                )}
              </td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDeleteCustomer(item.id)} // Add this onClick handler
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Add Person Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton id="modalheader">
          <Modal.Title>Add Person</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mobile No</Form.Label>
              <Form.Control
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                placeholder="Enter mobile number"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={handleSubmit}>Submit</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Approval;
